"use client"

import { Box, Button } from "@mui/material"
import { Upload as UploadIcon } from "@mui/icons-material"

export function FileUploadField({ id, file, onChange, accept = "image/*", label = "انتخاب تصویر" }) {
  return (
    <Box>
      <input accept={accept} type="file" onChange={onChange} hidden id={id} />
      <label htmlFor={id}>
        <Button
          component="span"
          fullWidth
          variant="outlined"
          startIcon={<UploadIcon />}
          sx={{
            py: 2,
            borderStyle: "dashed",
            borderColor: file ? "primary.main" : "grey.400",
          }}
        >
          {file ? file.name : label}
        </Button>
      </label>
    </Box>
  )
}
